import { render, staticRenderFns } from "./Theater.vue?vue&type=template&id=d8aa0dda&"
import script from "./Theater.vue?vue&type=script&lang=js&"
export * from "./Theater.vue?vue&type=script&lang=js&"
import style0 from "./Theater.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports